import { useState } from 'react';
import {
  Calendar as CalendarIcon, ChevronLeft, ChevronRight,
  Clock, Phone, Users, Video, MapPin,
  Plus, Filter
} from 'lucide-react';

export default function CalendarPage() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [view, setView] = useState('month');

  const days = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
  const events = [
    { id: 1, title: 'Appel Jean Dupont', time: '10:30', type: 'call', day: 15 },
    { id: 2, title: 'Réunion équipe', time: '14:00', type: 'meeting', day: 15 },
    { id: 3, title: 'Présentation client', time: '11:00', type: 'presentation', day: 16 },
    { id: 4, title: 'Suivi deal', time: '09:30', type: 'deal', day: 17 }
  ];

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
          Calendrier
        </h1>
        <div className="flex gap-2">
          <button className="px-4 py-2 bg-cyan-600 rounded-lg text-white flex items-center gap-2">
            <Plus size={18} />
            Nouvel événement
          </button>
        </div>
      </div>

      {/* Navigation */}
      <div className="flex items-center justify-between bg-gray-900 p-4 rounded-xl border border-gray-800">
        <div className="flex items-center gap-4">
          <button className="p-2 hover:bg-gray-800 rounded-lg">
            <ChevronLeft size={20} className="text-gray-400" />
          </button>
          <h2 className="text-xl font-semibold text-white">Février 2026</h2>
          <button className="p-2 hover:bg-gray-800 rounded-lg">
            <ChevronRight size={20} className="text-gray-400" />
          </button>
        </div>
        <div className="flex gap-2">
          {['month', 'week', 'day'].map(v => (
            <button
              key={v}
              onClick={() => setView(v)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition ${
                view === v ? 'bg-cyan-600 text-white' : 'text-gray-400 hover:text-white hover:bg-gray-800'
              }`}
            >
              {v === 'month' ? 'Mois' : v === 'week' ? 'Semaine' : 'Jour'}
            </button>
          ))}
        </div>
      </div>

      {/* Calendrier */}
      <div className="bg-gray-900 rounded-xl border border-gray-800 overflow-hidden">
        {/* Jours */}
        <div className="grid grid-cols-7 border-b border-gray-800">
          {days.map(day => (
            <div key={day} className="p-4 text-center text-gray-400 font-medium">
              {day}
            </div>
          ))}
        </div>

        {/* Cases */}
        <div className="grid grid-cols-7 auto-rows-fr">
          {Array.from({ length: 28 }).map((_, i) => {
            const dayEvents = events.filter(e => e.day === i + 1);
            return (
              <div key={i} className="min-h-32 p-2 border-r border-b border-gray-800 hover:bg-gray-800/30 transition">
                <span className="text-sm text-gray-400">{i + 1}</span>
                <div className="mt-1 space-y-1">
                  {dayEvents.map(event => (
                    <div
                      key={event.id}
                      className={`p-1 rounded text-xs truncate ${
                        event.type === 'call' ? 'bg-green-500/20 text-green-400' :
                        event.type === 'meeting' ? 'bg-blue-500/20 text-blue-400' :
                        'bg-purple-500/20 text-purple-400'
                      }`}
                    >
                      {event.time} - {event.title}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}